import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=0b08c4e0"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"
import style0 from "./Multiple.vue?vue&type=style&index=0&id=0b08c4e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports